import { render, staticRenderFns } from "./TenantShowDetailsTab.vue?vue&type=template&id=0db90122"
import script from "./TenantShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./TenantShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports